import { AbstractHttpService } from './abstracts/abstract-http.service';
import { Injectable } from '@angular/core';
import { AccountSession } from '../interfaces/account-session';
import { User } from '../interfaces/user';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { UserService } from './user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class AccountService extends AbstractHttpService {
  constructor(
    private router: Router,
    private userService: UserService,
    private cookieService: CookieService,
    private translateService: TranslateService
  ) {
    super('account');
  }

  createAccount(items: { password: string; email: string }) {
    return this.post<AccountSession>('create', {
      ...items,
      domainName: this.environmentConfig.host,
      countryCode: this.environmentConfig.countryCode[0],
      langCode: this.translateService.currentLang ? this.translateService.currentLang : 'fr',
    });
  }

  signInAccount(items: { password: string; email: string }) {
    return this.post<AccountSession>('sign-in', {
      ...items,
      domainName: this.environmentConfig.host,
    });
  }

  editAccount(items: Partial<User>) {
    return this.patch<User>('', items).pipe(
      catchError((err) => {
        if (err instanceof HttpErrorResponse) {
          // @TODO: Err
        }
        return throwError(err);
      })
    );
  }

  resetPassword(email: string) {
    return this.post<void>('password-reset', {
      email,
      domainName: this.environmentConfig.host,
    });
  }

  resetConfirmPassword(items: { token: string; password: string }) {
    return this.patch<void>('password-reset-confirm', {
      token: items.token,
      password: items.password,
      domainName: this.environmentConfig.host,
    });
  }

  getAccount() {
    return this.get<User>('').pipe(
      catchError((err) => {
        this.logout();
        return throwError(err);
      })
    );
  }

  private logout() {
    localStorage.removeItem('token');
    this.cookieService.delete('token');
    this.userService.reset();
    void this.router.navigateByUrl('/');
  }
}
